import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LaudosCDService } from "./laudos-cd.service";
import { LaudosCDModel } from "./laudos-cd.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { ClientesService } from "../clientes/clientes.service";
import { ExportadoresService } from "../exportadores/exportadores.service";
import { TerminaisService } from "../terminais/terminais.service";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { FichasService } from "../fichas/fichas.service";

declare var swal, $: any;

@Component({
  selector: 'app-laudos-cd',
  templateUrl: './laudos-cd.component.html'
})
export class LaudosCDComponent extends Components implements OnInit {

  laudos: LaudosCDModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };
  permissoesMenu = [];

  selecionarTodos: boolean = false;
  selecionados: any = {};
  processandoItem: any = {};
  carregandoAcoesEmMassa: boolean = false;
  idLaudoParaEnviarEmail: string;
  emailDestinatario: string = '';
  enviandoEmail: boolean = false;

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {
    "status_pesquisa": "",
    "data_de": "",
    "data_ate": "",
    "id_produto": "",
    "id_cliente": "",
    "id_exportador": "",
    "id_terminal": "",
    "referencia": "",
    "numero": "",
    "ordem_campo": "data_inspecao",
    "ordem_direcao": "d"
  };

  listStatusFichas = [];
  listClientes = [];
  listExportadores = [];
  listTerminal = [];
  listProdutos = [];

  constructor(
    formBuilder: FormBuilder,
    private laudosService: LaudosCDService,
    private clientesService: ClientesService,
    private exportadoresService: ExportadoresService,
    private terminaisService: TerminaisService,
    private mercadoriasService: MercadoriasService,
    private fichasService: FichasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    this.formPesquisaAvancada = formBuilder.group({
      status_pesquisa: [],
      data_de: [],
      data_ate: [],
      id_produto: [],
      id_cliente: [],
      id_exportador: [],
      id_terminal: [],
      referencia: [],
      numero: []
    });

    this.loginService.getUserInfo().subscribe(data => {
      let permissoes = [];
      for (let i in data.privilegios) {
        if (data.privilegios[i].consultar || data.privilegios[i].editar) {
          permissoes.push(String(data.privilegios[i].id_acao));
        }
        if (data.privilegios[i].id_acao == '24') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
      this.permissoesMenu = permissoes;
    });

    this.fichasService.getStatus().subscribe(
      res => this.listStatusFichas = res.Payload,
      err => this.func.showErro(err.json())
    );

    this.clientesService.get(null, null, ['id_cliente', 'nome_tratamento']).subscribe(
      res => this.listClientes = res.Payload,
      err => this.func.showErro(err.json())
    );

    this.exportadoresService.get().subscribe(
      res => this.listExportadores = res.Payload,
      err => this.func.showErro(err.json())
    );

    this.terminaisService.get().subscribe(
      res => this.listTerminal = res.Payload,
      err => this.func.showErro(err.json())
    );

    this.mercadoriasService.get(null, null, ['id', 'nome_padrao']).subscribe(
      res => this.listProdutos = res.Payload,
      err => this.func.showErro(err.json())
    );
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = Object.assign(this.filtroPesquisa, filtroSalvo);
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }

    this.getPage(1);
  }

  setOrdem(campo: string) {
    if (this.filtroPesquisa.ordem_campo === campo) {
      this.filtroPesquisa.ordem_direcao = (this.filtroPesquisa.ordem_direcao === 'a') ? 'd' : 'a';
    } else {
      this.filtroPesquisa.ordem_campo = campo;
      this.filtroPesquisa.ordem_direcao = 'a';
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
  }

  delete(laudo) {
    let laudos = this.laudos;
    let laudosService = this.laudosService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarLaudoCD') + (laudo.referencia || ''),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(laudos);
        }

        let index = laudos.indexOf(laudo);
        laudos.splice(index, 1);

        laudosService.apagar(laudo.id_laudo_cd)
          .subscribe(res => {
            self.laudos = laudos;
          },
            err => {
              laudos.splice(index, 0, laudo);
              self.laudos = laudos;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if (this.filtroPesquisa.status_pesquisa != '') {
      filtros['id_status'] = this.filtroPesquisa.status_pesquisa;
    }

    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data_inspecao'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data_inspecao'] = 'ge:' + this.filtroPesquisa.data_de;
      }
      if (this.filtroPesquisa.data_ate) {
        filtros['data_inspecao'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }

    if (this.filtroPesquisa.id_produto != '') {
      filtros['id_produto'] = this.filtroPesquisa.id_produto;
    }
    if (this.filtroPesquisa.id_cliente != '') {
      filtros['id_cliente'] = this.filtroPesquisa.id_cliente;
    }
    if (this.filtroPesquisa.id_exportador != '') {
      filtros['id_exportador'] = this.filtroPesquisa.id_exportador;
    }
    if (this.filtroPesquisa.id_terminal != '') {
      filtros['id_terminal'] = this.filtroPesquisa.id_terminal;
    }
    if (this.filtroPesquisa.referencia != '') {
      filtros['referencia'] = "**:" + this.filtroPesquisa.referencia;
    }
    if (this.filtroPesquisa.numero != '') {
      filtros['numero'] = "**:" + this.filtroPesquisa.numero;
    }

    let sort = {};
    let campoSort = this.filtroPesquisa.ordem_campo || 'data_inspecao';
    let direcaoSort = this.filtroPesquisa.ordem_direcao || 'd';
    sort[campoSort] = direcaoSort;

    this.laudosService.getPaginacao(pagina, this.itensPorPagina, ['produto', 'cliente', 'exportador', 'status'], filtros, null, sort)
      .subscribe(data => {
        this.laudos = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  enviaParaCliente(id){
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaEnviarFichaCliente'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        self.processandoItem[id] = true;
        self.laudosService.enviarLaudoParaCliente(id)
          .subscribe(res => {
              delete self.processandoItem[id];
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.notificadoComSucesso'), "success");
            },
            err => {
              delete self.processandoItem[id];
              self.func.showErro(err.json());
            });
      });
  }

  alteraStatus(id_laudo, id_status, notificar: boolean = true){
    let laudosService = this.laudosService;
    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaAlterarStatus'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){
        self.processandoItem[id_laudo] = true;
        laudosService.setStatus(id_laudo, id_status, notificar)
          .subscribe(res => {
              delete self.processandoItem[id_laudo];
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
              self.getPage(self.paginaAtual);
            },
            error => {
              delete self.processandoItem[id_laudo];
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");
              self.func.showErro(error.json());
            });
      });
  }

  marcarTodos(event) {
    this.selecionarTodos = event.target.checked;
    this.laudos.forEach(laudo => {
      this.selecionados[laudo.id_laudo_cd] = this.selecionarTodos;
    });
  }

  marcarItem(laudo, event) {
    this.selecionados[laudo.id_laudo_cd] = event.target.checked;

    if (!event.target.checked) {
      this.selecionarTodos = false;
    } else {
      let todosMarcados = true;
      for (let l of this.laudos) {
        if (!this.selecionados[l.id_laudo_cd]) {
          todosMarcados = false;
          break;
        }
      }
      this.selecionarTodos = todosMarcados;
    }
  }

  getSelecionadosIds(): string[] {
    let ids = [];
    for (let id in this.selecionados) {
      if (this.selecionados[id]) {
        ids.push(id);
      }
    }
    return ids;
  }

  executarAcaoEmMassa(acao: string, extraParam: any = null) {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaExecutarAcaoMassa'),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    }, function () {
      self.carregandoAcoesEmMassa = true;
      let total = selecionadosIds.length;
      let concluidos = 0;

      let finalizarSeConcluido = () => {
        if (concluidos == total) {
          self.carregandoAcoesEmMassa = false;
          swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.acaoConcluida'), "success");
          self.getPage(self.paginaAtual);
          self.selecionados = {};
          self.selecionarTodos = false;
        }
      };

      selecionadosIds.forEach(id => {
        let item = self.laudos.find(l => l.id_laudo_cd == <any>id);

        if (acao == 'status' && item && item.id_status == extraParam.id_status) {
          concluidos++;
          finalizarSeConcluido();
          return;
        }

        self.processandoItem[id] = true;

        let obs;
        if (acao == 'deletar') obs = self.laudosService.apagar(id);
        if (acao == 'notificar') obs = self.laudosService.enviarLaudoParaCliente(id);
        if (acao == 'status') obs = self.laudosService.setStatus(id, extraParam.id_status, extraParam.notifica);

        obs.subscribe(
          res => {
            delete self.processandoItem[id];
            concluidos++;
            finalizarSeConcluido();
          },
          err => {
            delete self.processandoItem[id];
            concluidos++;
            self.func.showErro(err.json());
            if (concluidos == total) {
              self.carregandoAcoesEmMassa = false;
              self.getPage(self.paginaAtual);
            }
          }
        );
      });
    });
  }

  downloadPDFsEmMassa() {
    let selecionadosIds = this.getSelecionadosIds();
    if (selecionadosIds.length == 0) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    // Filtra para aceitar apenas itens com status online (id_status == 2)
    let onlineIds = selecionadosIds.filter(id => {
      let item = this.laudos.find(l => l.id_laudo_cd == <any>id);
      return item && item.id_status == 2;
    });

    if (onlineIds.length == 0) {
      swal("Aviso", "Selecione pelo menos um laudo CD com status online.", "warning");
      return;
    }

    this.carregandoAcoesEmMassa = true;
    this.laudosService.downloadZipPdfs(onlineIds)
      .subscribe(
        json => {
          this.carregandoAcoesEmMassa = false;
          if (json && json.Success && json.Payload) {
            window.open(this.laudosService.dominio + json.Payload, '_blank');
            this.selecionados = {};
            this.selecionarTodos = false;
          } else {
            swal("Erro", "Erro ao gerar ZIP dos PDFs.", "error");
          }
        },
        error => {
          this.carregandoAcoesEmMassa = false;
          this.func.showErro(error.json());
        }
      );
  }

  abrirModalEnviarEmail(id) {
    this.idLaudoParaEnviarEmail = id;
    this.emailDestinatario = '';
    this.enviandoEmail = false;
    $('#modalEnviarEmail').modal('show');
  }

  enviarEmail() {
    if (!this.emailDestinatario || !this.func.validaEmail(this.emailDestinatario)) {
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.emailInvalido'), "error");
      return;
    }

    this.enviandoEmail = true;
    this.laudosService.enviarLaudoParaEmailEspecifico(this.idLaudoParaEnviarEmail, this.emailDestinatario)
      .subscribe(
        res => {
          this.enviandoEmail = false;
          $('#modalEnviarEmail').modal('hide');
          swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.emailEnviadoSucesso'), "success");
        },
        err => {
          this.enviandoEmail = false;
          this.func.showErro(err.json());
        }
      );
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    if (this.filtroPesquisa.data_de && !this.filtroPesquisa.data_ate) {
      this.filtroPesquisa.data_ate = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = {
      "status_pesquisa": "",
      "data_de": "",
      "data_ate": "",
      "id_produto": "",
      "id_cliente": "",
      "id_exportador": "",
      "id_terminal": "",
      "referencia": "",
      "numero": "",
      "ordem_campo": "data_inspecao",
      "ordem_direcao": "d"
    };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }
}




// WEBPACK FOOTER //
// ./src/app/laudos-cd/laudos-cd.component.ts